<template>
  <footer class="bg-black py-8 flex items-center justify-center flex-col">
    <div class="mt-2 shareon" data-url="https://mouvi.netlify.app/">
      <a
        class="twitter"
        href="https://twitter.com/"
        target="_blank"
        data-title="Looking for the next movie to watch? Mouvi got you covered for that."
        data-via="samador9"
      >
        <button
          class="bg-blue-500 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
          type="button"
        >
          <i class="fab fa-twitter"></i>
        </button>
      </a>
      <a
        class="facebook"
        href="https://facebook.com/"
        target="_blank"
        data-title="Looking for the next movie to watch? Mouvi got you covered for that."
      >
        <button
          class="bg-blue-500 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
          type="button"
        >
          <i class="fab fa-facebook-f"></i>
        </button>
      </a>
    </div>
    <div class="text-white my-2">
      Powered by
      <img src="@/assets/images/tmdbLogo.svg" alt="" />
    </div>
    <div class="text-white mt-6">
      &copy; 2021 - Developed by
      <a
        href="https://twitter.com/samador9"
        target="_blank"
        rel="noopener noreferrer"
        class="text-white font-semibold hover:underline"
        >SAMADOR</a
      >
    </div>
  </footer>
</template>
